export const changeParamsToQuery = (filter) => {

  let paramString = '';
  Object.keys(filter).forEach(function (key, index) {
    if (filter[key] !== undefined && filter[key] !== 'undefined') {
      paramString += (index > 0) ? '&' + key + '=' + filter[key] : '?' + key + '=' + filter[key]
    }
  })
  return paramString;
  
}